import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { BooleanInput } from "@angular/cdk/coercion";
import { Subject } from "rxjs";
import { User } from "app/core/user/user.model";
import { UserService } from "app/core/user/user.service";

import { environment } from "environments/environment";
import { FuseConfigService } from "../../../../@fuse/services/config";

@Component({
    selector: "user-menu",
    templateUrl: "./user-menu.component.html",
    styleUrls: ["./user-menu.component.scss"],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: "userMenu",
})
export class UserMenuComponent implements OnInit, OnDestroy {
    static ngAcceptInputType_showAvatar: BooleanInput;

    @Input() showAvatar: boolean = true;
    @Input() isExpandable: boolean = false;

    public user: User;
    public token: string;
    public accountRoute: string;
    public isExpanded = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        public router: Router,
        private _userService: UserService,
        private _fuseConfigService: FuseConfigService,
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to user changes
        this.user = this._userService.user$;
        this._changeDetectorRef.markForCheck();
        this.token = localStorage.getItem("access_token");
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Sign out
     */
    signOut(): void {
        this.router.navigate(["/sign-out"]);
    }

    toggleDarkTheme() {
        const scheme = localStorage.getItem("theme") == "dark" ? "light" : "dark";
        localStorage.setItem("theme", scheme);
        this._fuseConfigService.config = { scheme };
    }

    redirectToAccount() {
        window.location.href = `${environment.vars.next}/account`;
    }

    redirectToAccounts() {
        window.location.href = `${environment.vars.next}/account/list`;
    }
}
